import { Component, Input, OnDestroy, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { Document } from '../../models/document';
import { Person } from '../../models/person';
import { State } from '../../models/state';
import { PersonService } from '../../services/person.service';
import { AbstractForm } from '../../utils/abstract-form';
import { GeneralService } from '../../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MainMenuService } from '../../services/mainmenu.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Subscription } from 'rxjs';
import { SnackBarService } from '../../services/snackbar.service';
import { GotoAction } from '../../models/action';
import { AppLoadingService } from '../../services/apploading.service';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { Options } from '@m0t0r/ngx-slider';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

declare var $: any;

@Component({
    selector: 'person',
    templateUrl: './person.component.html',
    styleUrls: ['./person.component.scss']
})
export class PersonComponent extends AbstractForm implements AfterViewInit, OnDestroy {

    dialogRef: MatDialogRef<any>;

    @Input() person_id: any;

    @ViewChild('reasonReject') reasonReject:ElementRef;

    protected actionSubscription: Subscription;

    person: Person = new Person();

    formDisabled: boolean = false;

    info: any = {};

    moduleTypes: any;
    perfil_id: any;
    states: State[];
    personFiles : any = [];
    personType = 'company';

    individual = false;

    filesAvatar : any = [];
    filesLogo : any = [];
    filesGeneral : any = [];
    filesSignature : any = [];
    filesAuthorization : any = [];
    filesDrive : any = [];
    filesSite : any = [];
    
    forms: AbstractForm[] = [];
    formArry: FormArray;

    passGroup : FormGroup;

    rangeText:any = '';

    phoneMaskStr = '00 (00) 0000-0000';

    rangeOptions:Options = {
        showTicksValues: true,
        stepsArray: [
            { value: 0, legend: "Padrão" },
            /*{ value: 1, legend: ""},
            { value: 2, legend: "" },
            { value: 3, legend: ""},*/
            { value: 4, legend: "Logo visível no mapa" },
            /*{ value: 5, legend: ""},
            { value: 6, legend: "" },
            { value: 7, legend: "" },
            { value: 8, legend: "" },
            { value: 9, legend: "" }*/
        ]        
      };

    saving = false;

    generalSubscription:Subscription;
    formChanges:Subscription;

    params:any={};

    constructor(formBuilder: FormBuilder,
        logger: LoggerService,
        protected router: Router,
        private personService: PersonService,
        private gs: GeneralService,
        protected als: AppLoadingService,
        protected httpService : HttpService,
        protected activatedRoute: ActivatedRoute,
        protected snackBarService: SnackBarService,
        protected mms: MainMenuService,
        protected auth: AuthService,
        protected cdr: ChangeDetectorRef,
        public dialog: MatDialog,
    ) {
        super(formBuilder, logger,false);

        if(this.activatedRoute.snapshot.data['controller'])
            new this.activatedRoute.snapshot.data['controller'](mms,router,auth,gs);

        this.actionSubscription = this.personService.setActionSubscribe((result) => this.actionController(result));
        this.formArry = this.formBuilder.array([]);

      

        




        this.passGroup = this.formBuilder.group({
            password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]]
        });
    }

    ngAfterViewInit() {
        this.person_id = this.params?.public_idtext || this.activatedRoute.snapshot.paramMap.get('id');

        if(this.person_id == 'new'){
            this.setDefault();
        } else
            this.personService
                .loadPerson(this.person_id)
                .then((result) => {
                    this.person = result;

                    this.generalSubscription = this.gs.generalData$.subscribe(result => {
                        if(result){
                            this.updatePerson();
                            this.setDefault();
                            this.setDirty(false); 
                        }
                    });
                })
                .catch((err) => { console.log(err); this.gs.error(err);});
                
    }

    setDefault(){
        this.formDefault();
        this.isIndividual();
        if(this.person.username)
            this.getControl('email').disable();
            
        setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip({
                trigger : 'hover'
            });
            this.endLoading();
            this.cdr.detectChanges();
        },600);

        this.formChanges = this.formGroup.controls['type'].valueChanges.subscribe(r => {
            this.isIndividual();
        });        

        this.info.status = this.person_id =='new'? 'Novo' : 'Editando';
    }

    updatePerson(){

        this.filesAvatar = this.person.files.filter(item => item.gallery == 'public.person.avatar') || [];
        this.filesLogo = this.person.files.filter(item => item.gallery == 'public.person.logo') || [];
        this.filesGeneral = this.person.files.filter(item => item.gallery == 'public.person.general') || [];
        this.filesSignature = this.person.files.filter(item => item.gallery == 'private.person.signature') || [];
        this.filesAuthorization = this.person.files.filter(item => item.gallery == 'private.person.authorization_model') || [];
        this.filesDrive = this.person.files.filter(item => item.gallery == 'private.person.drive') || [];
        this.filesSite = this.person.files.filter(item => item.gallery == 'public.person.site') || [];

        this.person.verification?.list.map(item => {
            if(item?.data?.files) 
                item.data.files = this.getVerificationImages(item.data.files);
        });


    }

    ngOnDestroy(){
        this.actionSubscription?.unsubscribe();
        this.generalSubscription?.unsubscribe();
        this.formChanges?.unsubscribe();
    }

    private verificationItemSelected = null;

    actionController(action, item:any = null){
        if(action == null)
          return;
  
        switch(action){
          case 'back':
            this.back();
          break;
          case 'verification_approved':
            this.actionVerification(item, {status: 2 ,notify: 1});
          break;
          case 'verification_reject_set':
            this.verificationItemSelected = item;
          break;
          case 'verification_reject':
            if(this.verificationItemSelected)
                this.actionVerification(this.verificationItemSelected, {status: -1 ,notify: 1,observation:this.reasonReject.nativeElement.value || ''})
                    .then(result => {
                        $('#rejectModal').modal('hide');
                    });
          break;
          case 'verification_cancel':
            this.actionVerification(item, {status: -5 ,notify: false});
          break;
          case 'change_password':

            if(!this.person?.username)
                return;

            this.als.setLoaded(false, 'actionChangePassword');

            return this.httpService.post<any>(API.person.admin.setuserpassword, {
                username:this.person.username,
				password:this.passGroup.controls.password.value
            })
            .then(result => {
                //console.log(result);
                this.gs.error(null, 'Senha alterada com sucesso');
            })
            .catch(err => {
                this.gs.error(err)
            })
            .finally(() => {
                this.als.setLoaded(true, 'actionChangePassword');
            });
                
          break;
          default:
            this.save(action);
          break;
        }
        this.personService.setAction(null);
    }

    actionVerification(item, data): Promise<any> {

        
        this.als.setLoaded(false, 'actionVerification');

        return this.httpService.post<any>(API.person.admin.verification, {verification_id:item.verification_id, ...data})
                .then(result => {

                    item.status = data.status;
                    item.notify = data.notify;
                    if(data.observation)
                        item.observation = data.observation;

                    //this.reload(this.person.id);

                    window.location.reload();

                    return result;
                })
                .catch((err) => {
                    this.gs.error(err)
                })
                .finally(() => {
                    this.als.setLoaded(true, 'actionVerification');
                });
    }


    back(){

        let changedProperties = [];
    
        Object.keys(this.formGroup?.controls).forEach((name) => {
          let currentControl = this.getControl(name);
    
          if (currentControl.dirty)
            changedProperties.push(name);
        });
        
        if (!this.formGroup.dirty) {
          this.goBack();
          return ;
        }
    
        this.snackBarService.open('Cadastro não concluído, deseja cancelar?', 'Sim')
          .onAction().subscribe(() => {
            this.goBack();
          });
      }
    
      save(action){
        
        var data = this.updateObject();
        this.saving = true;
    
        let th = this;
    
        this.personService.executeAction(action, this.personService.convertToDto(data), 
          function(value: any){ //then

            th.saveComplete(action, value !== null? value : data.id);
            th.snackBarService.open('Dados salvos com sucesso');
          },
          function(error){
              console.log(error);
            th.gs.error(error,'Ocorreu um erro ao salvar os dados');
          },
          function(){ //finally
            th.saving = false;
          });
          
      }

      goBack(){
        return new GotoAction(null, '', [this.gs.getModule(),'person'], { skipLocationChange: true }, this.router).execute();
      }

      reload(id){
        this.als.setLoaded(false,this.gs.getBase()+'/PersonLoad');
        this.personService
            .loadPerson(id)
            .then((result) => {
                this.person = result;

                this.person_id = this.person.id;
                this.updatePerson();
                this.setDirty(false);
                //this.setDefault();                    
            })
            .catch(this.gs.error)
            .finally(()=>{
                this.als.setLoaded(true,this.gs.getBase()+'/PersonLoad');
                this.endLoading();
            });
      }
    

    receiveEvent(form: AbstractForm|any): void {
        

        if(form instanceof AbstractForm){
            this.forms.push(form);
        } else if(form=='dirty') {
            this.formGroup.markAsDirty();
        }
    }

    saveComplete(action, id){
        let doBack = this.personService.getActionToBack(action);
    
        if(doBack)
          this.goBack();
        else {
          this.reload(id);
        }
    
      }

    buildFormGroup(): FormGroup {
        
        this.moduleTypes = this.gs.getGeneralData().modules;
        this.perfil_id = this.gs.getGeneralData().perfil;
        this.states = this.gs.getGeneralData().states;
        this.phoneMask(this.person?.phone.phone);
        let fb = this.formBuilder.group({
            type: [this.person.type, Validators.required],
            person_name: [this.person.person_name, Validators.required],
            company_name: [this.person.company_name],
            friendly_name: [this.person.friendly_name],
            birthday: [this.person.birthday],
            document: [this.person.document.number, this.getDocumentValidator(this.person.type)],
            document_verified: [this.person.document.verified],
            creci: [this.person.creci.number],
            creci_verified: [this.person.creci.verified],
            creci_state: [this.person.creci.state],
            email: [this.person.email.email, [Validators.email]],
            email_verified: [this.person.email.verified],
            cellphone: [this.person.cellphone.phone],
            cellphone_verified: [this.person.cellphone.verified],
            cellphone_whatsapp: [this.person.cellphone.whatsapp],
            phone: [this.person.phone.phone],
            phone_verified: [this.person.phone.verified],
            phone_whatsapp: [this.person.phone.whatsapp],
            perfil_id: [this.person.perfil_id, Validators.required],
            site: [this.person.site],
            instagram: [this.person.instagram],
            facebook: [this.person.facebook],
            tiktok: [this.person.tiktok],
            youtube: [this.person.youtube],
            twitter: [this.person.twitter],
            linkedin: [this.person.linkedin],
            about: [this.person.about],
            deny_requesting: [this.person.deny_requesting],
            visibility_score: [this.person.visibility_score],
            allow_authorization_requests: [this.person.allow_authorization_requests],
            allow_material_requests: [this.person.allow_material_requests],
            allow_training_requests: [this.person.allow_training_requests],
            allow_proposal_requests: [this.person.allow_proposal_requests]
        });

        fb.get('type').valueChanges.subscribe(value => {
            this.getControl('document').setValidators(this.getDocumentValidator(value));
        });

        return fb;
    }
    
    getStatus(){
        return 'Novo';
    }

    isIndividual() {
        this.person.type = this.getControlValue('type');
        this.individual =  this.person?.isIndividual();
    }

    getCurrentStatus(){
        return this.person?.status;
    }

    isSaveDisabled() {
        return this.saving || this.formGroup.invalid;
    }

    // next(msg: any) {
    //     if (msg instanceof Person) {
    //         this.person = msg;
    //     }

    //     this.updateControls();
    // }

    updateControls() {
        this.phoneMask(this.person?.phone.phone);
        this.setControlValue('type', this.person?.type);
        this.setControlValue('person_name', this.person?.person_name);
        this.setControlValue('company_name', this.person?.company_name);
        this.setControlValue('friendly_name', this.person?.friendly_name);
        this.setControlValue('birthday', this.person?.birthday);
        this.setControlValue('document', this.person?.document.number);
        this.setControlValue('document_verified', this.person?.document.verified);
        this.setControlValue('creci', this.person?.creci.number);
        this.setControlValue('creci_verified', this.person?.creci.verified);
        this.setControlValue('creci_state', this.person?.creci.state);
        this.setControlValue('email', this.person?.email.email);
        this.setControlValue('email_verified', this.person?.email.verified);
        this.setControlValue('cellphone', this.person?.cellphone.phone);
        this.setControlValue('cellphone_verified', this.person?.cellphone.verified);
        this.setControlValue('cellphone_whatsapp', this.person?.cellphone.whatsapp);
        this.setControlValue('phone', this.person?.phone.phone);
        this.setControlValue('phone_verified', this.person?.phone.verified);
        this.setControlValue('phone_whatsapp', this.person?.phone.whatsapp);
        this.setControlValue('perfil_id', this.person?.perfil_id, this.formGroup, {disabled : this.person?.perfil_id != 'new'});
        this.setControlValue('site', this.person?.site);
        this.setControlValue('instagram', this.person?.instagram);
        this.setControlValue('facebook', this.person?.facebook);
        this.setControlValue('tiktok', this.person?.tiktok);
        this.setControlValue('youtube', this.person?.youtube);
        this.setControlValue('twitter', this.person?.twitter);
        this.setControlValue('linkedin', this.person?.linkedin);
        this.setControlValue('about', this.person?.about);
        this.setControlValue('deny_requesting', this.person?.deny_requesting);
        this.setControlValue('visibility_score', this.person?.visibility_score);
        this.setControlValue('allow_authorization_requests', this.person?.allow_authorization_requests);
        this.setControlValue('allow_material_requests', this.person?.allow_material_requests);
        this.setControlValue('allow_training_requests', this.person?.allow_training_requests);
        this.setControlValue('allow_proposal_requests', this.person?.allow_proposal_requests);
    }

    updateObject(): any {
        if(!this.person)
            return this.person;
            
        let birthday = this.getControlValue('birthday');

        this.person.person_name = this.getControlValue('person_name');
        this.person.company_name = this.getControlValue('company_name');
        this.person.friendly_name = this.getControlValue('friendly_name');
        this.person.birthday = birthday?.length == 8? birthday.substr(4,8)+'-'+birthday.substr(2,2)+'-'+birthday.substr(0,2)+' 00:00:00' : '';
        this.person.type = this.getControlValue('type');
        this.person.email.email = this.getControlValue('email');
        this.person.email.verified = this.getControlValue('email_verified');
        this.person.document.number = this.getControlValue('document');
        this.person.document.verified = this.getControlValue('document_verified');
        this.person.creci.number = this.getControlValue('creci');
        this.person.creci.state = this.getControlValue('creci_state');
        this.person.creci.verified = this.getControlValue('creci_verified');
        this.person.cellphone.phone = this.getControlValue('cellphone');
        this.person.cellphone.whatsapp = this.getControlValue('cellphone_whatsapp');
        this.person.cellphone.verified = this.getControlValue('cellphone_verified');
        this.person.phone.phone = this.getControlValue('phone');
        this.person.phone.whatsapp = this.getControlValue('phone_whatsapp');
        this.person.phone.verified = this.getControlValue('phone_verified');
        this.person.perfil_id = this.getControlValue('perfil_id');
        this.person.site = this.getControlValue('site');
        this.person.instagram = this.getControlValue('instagram');
        this.person.facebook = this.getControlValue('facebook');
        this.person.tiktok = this.getControlValue('tiktok');
        this.person.youtube = this.getControlValue('youtube');
        this.person.twitter = this.getControlValue('twitter');
        this.person.linkedin = this.getControlValue('linkedin');
        this.person.about = this.getControlValue('about');
        this.person.deny_requesting = this.getControlValue('deny_requesting')? this.getControlValue('deny_requesting') : 0;
        this.person.visibility_score = this.getControlValue('visibility_score')? this.getControlValue('visibility_score') : 0;
        this.person.allow_authorization_requests = this.getControlValue('allow_authorization_requests')? 1 : '0';
        this.person.allow_material_requests = this.getControlValue('allow_material_requests')? 1 : '0';
        this.person.allow_training_requests = this.getControlValue('allow_training_requests')? 1 : '0';
        this.person.allow_proposal_requests = this.getControlValue('allow_proposal_requests')? 1 : '0';

        this.person.address = this.getFormValues(this.forms[0]?.formGroup) || {};
        
        return this.person;
    }

    getDocumentValidator(type: string) {
        let docType = 'cnpj';
        if (type == Person.INDIVIDUAL) {
            docType = 'cpf';
        }
        return Document.validate(docType);
    }

    getVerificationImages(files:any){
        if(!files.length)
            return '';
 
        return Object.assign([], this.person?.files?.filter(item => item.file_id && files.indexOf(item.file_id.toString()) > -1)).map(item=>({...item, description : item.gallery}));

    }

    
  phoneMethod(event,field){
    switch(event.type){
      case 'focus':
        if(!this.getControlValue(field))
          this.setControlValue(field,'55');
      break;
      case 'blur':
        if(this.getControlValue(field) == '55')
          this.setControlValue(field,null);
      break;
    }
  }

  phoneMask(event:any){
    let len = event?.target?.value?.length || event?.length;
    let nv:any = false;
    if(event?.keyCode == 8){
      len = len-2;
      nv = this.getControlValue('phone');
      nv = nv.substr(0,nv.length-1);
    } else if((event?.keyCode >= 48 && event?.keyCode <= 57) || (event?.keyCode >= 96 && event?.keyCode <= 105)){
        nv = this.getControlValue('phone').substr(0,12)+event?.key;
        len++;
    }
    this.phoneMaskStr = (event?.target && len > 18) || (!event?.target && len > 12)? '00 (00) 00000-0000' : '00 (00) 0000-0000';

    if(nv)
        setTimeout(() => this.setControlValue('phone', nv),5);
    
  }
}